exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 895px) {\n.page-block__heading[data-v-103675e0] {\n    padding: 1.3333333333vw 2.6666666667vw;\n    min-height: 13.3333333333vw;\n}\n}\n", ""]);

// exports
